module.exports = "<h3 id=at-the-forefront-of-the-evolution-br-of-video-art>At the forefront of the evolution<br/> of video art</h3> <h4 id=new-york-times>New York Times</h4> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/carousel/when-i-close-my-eyes_2.md
// module id = 804
// module chunks = 0